module.exports = __webpack_public_path__ + "static/media/close.c702b326.svg";